// extracted by mini-css-extract-plugin
module.exports = {"deleteContainer":"_9e397ddb","textAlignCenter":"de3d19c4"};